var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUndock = function SvgUndock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.666 1.667h-10C5.746 1.667 5 2.413 5 3.333V5H3.333c-.92 0-1.667.746-1.667 1.667v10c0 .92.747 1.666 1.667 1.666h10c.92 0 1.667-.746 1.667-1.666V15h1.666c.921 0 1.667-.746 1.667-1.667v-10c0-.92-.746-1.666-1.666-1.666zm-3.333 15V15H6.666C5.747 15 5 14.254 5 13.333V6.667H3.333v10h10zM6.666 3.333v10h10v-10h-10zM10 5a.833.833 0 100 1.667h2.102L8.588 10.18a.87.87 0 101.231 1.23l3.514-3.513V10A.833.833 0 1015 10V5.833A.833.833 0 0014.166 5H10z",
    fill: "#fff"
  })));
};

export default SvgUndock;